import TableTemplate from "../TableTemplate/TableTemplate";
import styles from "../TableRightTemplate/TableRightTemplate.module.css";

interface TableRightTemplateProps {
  right: React.ReactNode;
  loadData: any;
  saveData?: any;
  createData?: any;
  deleteData?: any;
  title?: string;
  fields: any[];
  sortStateField?: string;
}

export default function TableRightTemplate(props: TableRightTemplateProps) {
  return (
    <div className={styles.layoutRight}>
      <div className={styles.main}>
        <TableTemplate
          loadData={props.loadData}
          saveData={props.saveData}
          createData={props.createData}
          deleteData={props.deleteData}
          title={props.title}
          fields={props.fields}
          sortStateField={props.sortStateField}
        />
      </div>
      <aside className={styles.right}>{props.right}</aside>
    </div>
  );
}